import React from "react";
import { Entity } from "@common/types/entity";
import { BreakableText } from "@design-system/BreakableText/BreakableText";
import { EntityAvatar } from "@components/avatar/EntityAvatar";
import { NavigationItem } from "@design-system/Navigation/NavigationItem";
import { NavigationMenu } from "@design-system/Navigation/NavigationMenu";
import { SettingsNavLink } from "./SettingsNavLink";
import { getEntityPaneKey } from "./lib";
import { EntitySettingsPages } from "./constants";

interface Props {
    entities: Entity[];
}

export const EntitySettingsNavigation: React.FC<Props> = ({ entities }) => (
    <>
        <header className="settings__navigation__workspaces-header">
            Entities
        </header>
        <NavigationMenu className="flex-column">
            {entities.map((entity) => (
                <SettingsNavLink
                    key={entity.id}
                    eventKey={getEntityPaneKey(
                        EntitySettingsPages.SETTINGS,
                        entity.id,
                    )}
                >
                    <NavigationItem
                        icon={
                            <EntityAvatar
                                entity={entity}
                                size="xs"
                                aria-hidden
                            />
                        }
                    >
                        <BreakableText text={entity.name} showTooltip />
                    </NavigationItem>
                </SettingsNavLink>
            ))}
        </NavigationMenu>
    </>
);
